import type { NavGroup, Publication } from '~/interfaces/publication';

import getNormalizedCategory from '~/utils/getNormalizedCategory';

import DropdownAccordion from './DropdownAccordion';
import DropdownLink from './DropdownLink';

interface Props {
  publication: Publication;
}

const NavGroups = ({ publication }: Props) => {
  const webTemplate = publication.web_template;
  const contentTags = publication.content_tags;
  const enableCategories = webTemplate.enable_customize_category_ids;
  const categoryIds = webTemplate.category_ids;
  const hasNavGroups = webTemplate.nav_groups.length > 0;

  return (
    <div className="">
      {hasNavGroups &&
        webTemplate.nav_groups.map((group: NavGroup) => {
          const isCategoryGroup = group.is_category_group;

          if (isCategoryGroup) {
            return (
              <DropdownAccordion key={group.id} navGroup={group}>
                {contentTags?.map((tag) => {
                  if (enableCategories && !categoryIds.includes(tag.id)) {
                    return null;
                  }

                  return (
                    <div key={tag.id}>
                      <DropdownLink
                        link={{
                          href: `/t/${getNormalizedCategory(tag.display)}`,
                          type: 'internal',
                        }}
                        text={tag.display}
                      />
                    </div>
                  );
                })}
              </DropdownAccordion>
            );
          }

          if (group.nav_links.length === 0) return null;

          if (group.nav_links.length === 1) {
            const isExternal = group.nav_links[0].external_link;

            return (
              <DropdownLink
                key={group.id}
                text={group.nav_links[0].cta_text}
                link={{
                  href: isExternal ? group.nav_links[0].href : `/c/${group.nav_links[0].href}`,
                  type: group.nav_links[0].external_link ? 'external' : 'internal',
                }}
              />
            );
          }

          return (
            <DropdownAccordion key={group.id} navGroup={group}>
              {group.nav_links.map((link) => {
                const isExternal = link.external_link;

                return (
                  <DropdownLink
                    key={link.id}
                    text={link.cta_text}
                    link={{
                      href: isExternal ? link.href : `/c/${link.href}`,
                      type: isExternal ? 'external' : 'internal',
                    }}
                  />
                );
              })}
            </DropdownAccordion>
          );
        })}
    </div>
  );
};

export default NavGroups;
